export enum NarIngestionStatus {
  HumanInTheLoop = "human_in_the_loop",
  Completed = "completed",
  InProgress = "in_progress",
  ToDo = "to_do",
  Error = "error",
}
